import { axios } from "@/utils";
import { SettingBranch, SettingCompany, SettingsIndicatorResponse, SettingsTypeTransaciontResponse } from "@/services/settings/types";

export const getSettingsBranch = (branchId: string) => async (): Promise<SettingBranch> => {
  const { data } = await axios.get(`/settings/branch/${branchId}`);
  return data.data;
}

export const getSettingsCompany = (companyId: string) => async (): Promise<SettingCompany> => {
  const { data } = await axios.get(`/settings/company/${companyId}`);
  // resolve(data.data);
  return data.data;
}

export const postSettingsCompany = async (data: Partial<SettingCompany>): Promise<SettingCompany> => {
  const { data: response } = await axios.post(`/settings/company`, data);
  return response.data;
}

export const putSettingsCompany = (companyId: string) => async (data: Partial<SettingCompany>): Promise<SettingCompany> => {
  const { data: response } = await axios.put(`/settings/company/${companyId}`, data);
  return response.data;
}

export const postSettingsBranch = async (data: Partial<SettingBranch>): Promise<SettingBranch> => {
  const { data: response } = await axios.post(`/settings/branch`, data);
  return response.data;
}

export const putSettingsBranch = (branchId: string) => async (data: Partial<SettingBranch>): Promise<SettingBranch> => {
  const { data: response } = await axios.put(`/settings/branch/${branchId}`, data);
  return response.data;
}


export const getSettingsIndicator = async (): Promise<SettingsIndicatorResponse[]> =>(await axios.get(`/indicators`)).data;

export const postSettingsIndicator = async (data: Partial<SettingsIndicatorResponse>): Promise<SettingsIndicatorResponse> => {
  const { data: response } = await axios.post(`/indicators`, [data]);
  return response.data;
}

export const putSettingsIndicatorSatus = async (id: number): Promise<SettingsIndicatorResponse> => {
  const { data: response } = await axios.put(`/indicators/status/${id}`);
  return response.data;
}

export const putSettingsIndicator = (id: number) =>  async (data: Partial<SettingsIndicatorResponse>): Promise<SettingsIndicatorResponse> => {
  const { data: response } = await axios.put(`/indicators/${id}`, data);
  return response.data;
}
              
export const getSettingsTransactionType = async () =>(await axios.get(`/transaction-type/company`)).data.data;

export const postSettingsTransactionType = async ( data: any ) => {
  const { data: response } = await axios.post(`/transaction-type`, data);
  return response.data;
  
}
export const putSettingsTransactionType = (id: number) =>  async (data: Partial<SettingsTypeTransaciontResponse>): Promise<SettingsTypeTransaciontResponse> => {
  const { data: response } = await axios.put(`/transaction-type`, data);
  return response.data;
}